import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "show",
    onAfterLeave: _ctx.afterLeave
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: "modal is-active custom-modal",
        id: _ctx.modalId,
        style: _normalizeStyle({ 'z-index': _ctx.zIndex }),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickBg && _ctx.onClickBg(...args)))
      }, [
        (!_ctx.isOverlay)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-background" }, null, -1)),
              _createElementVNode("div", {
                class: _normalizeClass(["modal-content", {'fullscreen': _ctx.modal.fullscreen }])
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), {
                  close: _ctx.close,
                  modalData: _ctx.modal
                }, null, 8, ["close", "modalData"]))
              ], 2),
              _createElementVNode("button", {
                class: "modal-close is-large",
                "aria-label": "close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close(null)))
              })
            ], 64))
          : _createCommentVNode("", true)
      ], 12, _hoisted_1), [
        [_vShow, _ctx.modal.show]
      ])
    ]),
    _: 1
  }, 8, ["onAfterLeave"]))
}